import { z } from "zod";

/**
 * Checks if the error is a ZodError
 * @param error - The error to check
 * @returns True if the error is a ZodError, false otherwise
 */
export function hasZodErrorShape(error: unknown): boolean {
  if (typeof error !== "object" || error === null) return false;
  const keys = ["code", "message", "path"];
  return keys.every((key) => key in (error as Record<string, unknown>));
}

export const transformUrl = (value: string) => {
  if (value.startsWith("http://") || value.startsWith("https://")) {
    return value;
  }
  return `https://${value}`;
};

// List of valid TLDs (you can make this more comprehensive)
const _VALID_TLDS = new Set([
  "com",
  "org",
  "net",
  "edu",
  "gov",
  "mil",
  "int",
  "co",
  "io",
  "dev",
  "app",
  "uk",
  "de",
  "fr",
  "it",
  "es",
  "nl",
  "au",
  "ca",
  "jp",
  "cn",
  "in",
  "br",
  "info",
  "biz",
  "name",
  "pro",
  "tv",
  "me",
  "cc",
  "ws",
  "ly",
  "ai",
  "xyz",
]);

const _hasValidTLD = (hostname: string): boolean => {
  const parts = hostname.toLowerCase().split(".");
  if (parts.length < 2) return false;

  const tld = parts[parts.length - 1];
  return _VALID_TLDS.has(tld);
};

export const urlCustomSchema = z
  .string()
  .min(1, "URL è obbligatorio")
  .transform(transformUrl)
  .pipe(
    z.url({
      protocol: /^https?$/,
      hostname: z.regexes.domain,
      error: "Inserisci un URL valido",
    }),
  );
// .refine(
//   (url) => {
//     try {
//       const urlObj = new URL(url);
//       return hasTLD(urlObj.hostname);
//     } catch {
//       return false;
//     }
//   },
//   {
//     message: "Comprati un dominio amico",
//   },
// );

export const portfolioUrlCustomSchema = z
  .string()
  .min(1, "URL è obbligatorio")
  .transform(transformUrl)
  .pipe(
    z.url({
      protocol: /^https?$/,
      hostname: z.regexes.domain,
      error: "Inserisci un URL valido",
    }),
  );

export const optionUrlCustomSchema = z
  .string()
  .optional()
  .transform((value) => (value ? transformUrl(value) : undefined))
  .pipe(
    z
      .url({
        protocol: /^https?$/,
        hostname: z.regexes.domain,
        error: "Inserisci un URL valido",
      })
      .optional(),
  );
// .refine(
//   (url) => {
//     if (!url) return true;
//     try {
//       const urlObj = new URL(url);
//       return hasTLD(urlObj.hostname);
//     } catch {
//       return false;
//     }
//   },
//   {
//     message: "Comprati un dominio amico",
//   },
// );
